/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.1",
    versionName: "0.2.0-nightly.2026.4.1",
    versionChannel: "nightly",
    buildDate: "2026-04-01T00:14:22.191Z",
    commitHash: "b6b730bc393c2713ad7469c1a25a30666fff8167",
};
